export const initialState = {
  authorized: false,
  username: '',
  token: ''
}